// Global Instructions Rule Applied!
//
// LPs (FUND MANAGEMENT → LPs, owner 2026-09-14) — Zod models for view__lps
// and view__lps_filter_options. One row per LP (the LP Allocation row set,
// lp_allocation__rows — one LP definition) with the account's team name and
// whether it is set, so "does every Active LP have a {{team_name}} greeting"
// is one filter pair. Keys follow the RPC's table__column convention; every
// response is strict-validated before it reaches UI state (CLAUDE.md).
import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import { FilterOptionSchema } from './relationships_model.ts'

export const LpRowSchema = z
  .object({
    accounts__id: z.string(),
    accounts__name: z.string(),
    accounts__team_name: z.string().nullish(),
    // 'Yes' | 'No' — the grid text for accounts.team_name being non-blank.
    prog__team_name_set: z.string(),
    comms_lp_statuses__id: z.string().nullish(),
    comms_lp_statuses__label: z.string().nullish(),
    // The LP's funds (Closed commitment or live prospect) as a label and as ids.
    prog__funds: z.string(),
    prog__fund_ids: z.array(z.string()).nullish(),
    prog__commitment_total: z.number().nullish(),
    prog__commitment_currency: z.string().nullish(),
    prog__commitment_total_fmt: z.string().nullish(),
    // Every current owner by name, ownership titles in cfg order.
    prog__owners: z.string()
  })
  .strict()
export type LpRow = z.infer<typeof LpRowSchema>
export const LpRowFields = makeFieldKeys(LpRowSchema)
export const validateLpRows = (data: unknown): LpRow[] => validateWithZodSchema(z.array(LpRowSchema), data, 'LP rows') as LpRow[]

export const LpsFilterOptionsSchema = z
  .object({
    comms_lp_statuses__id: z.array(FilterOptionSchema),
    funds__id: z.array(FilterOptionSchema),
    prog__team_name_set: z.array(FilterOptionSchema)
  })
  .strict()
export type LpsFilterOptions = z.infer<typeof LpsFilterOptionsSchema>
export const validateLpsFilterOptions = (data: unknown): LpsFilterOptions =>
  validateWithZodSchema(LpsFilterOptionsSchema, data, 'LPs filter options') as LpsFilterOptions
